import { JBaseApi } from '../base';
import { ApiWrapper, QuestionAnswerSelectResponseParams, QuestionAnswerUnselectResponseParams } from '../../types';
import { OF } from '../../util/network';

export class JQuestionAnswerApi extends JBaseApi {
    public selectResponse(
        params: QuestionAnswerSelectResponseParams,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'socialQuestion',
                f: 'selectResponse',
                ...params,
            } as OF,
            options?.signal,
        );
    }

    public unselectResponse(
        params: QuestionAnswerUnselectResponseParams,
        options?: {
            signal?: AbortSignal;
        },
    ): Promise<ApiWrapper<boolean>> {
        return this.network.post(
            {
                o: 'socialQuestion',
                f: 'unselectResponse',
                ...params,
            } as OF,
            options?.signal,
        );
    }
}
